const SPECIAL_VALIDATION_API_NAMES = [
    "too-many-files",
    "is-big-file",
    "is-correct-file",
];

export default SPECIAL_VALIDATION_API_NAMES;
